import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import FloatingCTA from '../../components/ui/FloatingCTA';
import HeroSection from './components/HeroSection';
import HowItWorksSection from './components/HowItWorksSection';
import FourGuidesSection from './components/FourGuidesSection';
import FeaturesSection from './components/FeaturesSection';
import WhoItsForSection from './components/WhoItsForSection';
import CommunitySignupSection from './components/CommunitySignupSection';
import FooterSection from './components/FooterSection';

const MainAppHomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-dvh bg-background text-foreground pb-[calc(7rem+env(safe-area-inset-bottom))] md:pb-0">
      <Header />
      <FloatingCTA />
      <main className="relative">
        <HeroSection />
        <HowItWorksSection />
        <FourGuidesSection />
        <FeaturesSection />
        <WhoItsForSection />
        <CommunitySignupSection />
      </main>
      <FooterSection />
    </div>
  );
};

export default MainAppHomePage;